import { LucideInfo } from 'lucide-react'
import { Tooltip } from '~/components/ui'
import { cn } from '~/utils'

type ParsedFieldError = {
  error?: string
  info?: string
}

export function parseFieldError(error: string | undefined): ParsedFieldError {
  if (!error) {
    return { error: undefined, info: undefined }
  }

  const match = error.match(/^(.*?)<(.+?)>$/)
  if (!match) {
    return { error, info: undefined }
  }

  const mainError = match[1].trim()
  const info = match[2].trim()

  return {
    error: mainError || error,
    info: info || undefined,
  }
}

type FieldErrorMessageProps = {
  error?: string
  className?: string
  tooltipClassName?: string
}

export function FieldErrorMessage({
  error,
  className,
  tooltipClassName,
}: FieldErrorMessageProps) {
  const { error: mainError, info } = parseFieldError(error)

  if (!mainError) {
    return null
  }

  return (
    <div className={cn('mt-2 flex items-center gap-1', className)}>
      <p className="text-sm text-red-600">{mainError}</p>
      {info && (
        <Tooltip.Provider delayDuration={200}>
          <Tooltip>
            <Tooltip.Trigger asChild>
              <span className="inline-flex items-center text-destructive">
                <LucideInfo className="h-4 w-4" />
              </span>
            </Tooltip.Trigger>
            <Tooltip.Content
              className={cn(
                'z-50 max-w-xs border-destructive bg-destructive text-destructive-foreground',
                tooltipClassName
              )}>
              <p>{info}</p>
            </Tooltip.Content>
          </Tooltip>
        </Tooltip.Provider>
      )}
    </div>
  )
}
